import { motion } from 'framer-motion'
import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII, SHADOWS } from 'styles/consts'
import { DROPDOWN_Z_INDEX } from 'consts/zIndex'

export const DropdownOverlayWrapper = styled(motion.div)<{
  width: number
  left: number
  top: number
  height: string
}>`
  position: fixed;
  width: ${props => `${props.width}px`};
  left: ${props => `${props.left}px`};
  top: ${props => `${props.top}px`};
  height: ${props => props.height};
  background: ${COLORS.surface};
  border-radius: ${RADII.card};
  box-shadow: ${SHADOWS.menu};
  z-index: ${DROPDOWN_Z_INDEX};
  overflow: hidden;
  display: flex;
  flex-direction: column;
`
